import React, { lazy, Suspense } from "react";
import CustomMeta from "../components/CustomMeta/CustomMeta";
import ExecutionEnvironment from "exenv";

// Components
const Admin = React.lazy(() =>
  import(/* webpackChunkName: "Admin" */ "../components/Admin/Admin")
);

import { makeStyles } from 'tss-react/mui';

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()(() => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function pricing() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Admin page`}
        description={`Admin page for Content Generator admins`}
        url={`https://contentgenerator.io/admin`}
      />
      <div>
        {ExecutionEnvironment.canUseDOM && (
          <Suspense fallback={<div />}>
            <Admin />
          </Suspense>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps)(pricing);
